import request from "@/utils/request/qbank-request";

// 接口配置
const API_BASE_URL =
  process.env.NODE_ENV === "development" ? "/aliyun" : "/aliyun";
const AUDIO_BASE_URL = "https://data.caidouenglish.com";

// 默认用户信息
const DEFAULT_USER_INFO = {
  uid: "JHSHshhsgg",
  userType: 2, // 2-老师
  buyTime: 1523935864,
  buyType: 4, // 4-永久
};

// 获取题库token
export function getQuestionBankToken(params: {
  appId: string;
  appSecret: string;
  expiresIn?: number;
}) {
  return request({
    url: `${API_BASE_URL}/business/content/token`,
    method: "post",
    data: params,
  });
}

// 通用获取内容接口
export function getQuestionBankReadContent(params: {
  token: string;
  uri: string;
  userInfo?: {
    uid?: string;
    userType?: number;
    buyTime?: number;
    buyType?: number;
    tid?: string;
  };
}) {
  const userInfo = { ...DEFAULT_USER_INFO, ...params.userInfo };

  // 手动构建查询字符串，确保方括号被正确编码
  const paramsArray = [
    `accessToken=${encodeURIComponent(params.token)}`,
    `uri=${encodeURIComponent(params.uri)}`,
    `userInfo%5Buid%5D=${encodeURIComponent(userInfo.uid)}`,
    `userInfo%5BuserType%5D=${encodeURIComponent(String(userInfo.userType))}`,
    `userInfo%5BbuyTime%5D=${encodeURIComponent(String(userInfo.buyTime))}`,
    `userInfo%5BbuyType%5D=${encodeURIComponent(String(userInfo.buyType))}`,
  ];

  if (userInfo.tid) {
    paramsArray.push(`userInfo%5Btid%5D=${encodeURIComponent(userInfo.tid)}`);
  }

  const queryString = paramsArray.join("&");

  return request({
    url: `${API_BASE_URL}/business/content/readContent?${queryString}`,
    method: "get",
  });
}

// 按学段获取教材
export function getTextbooksByPeriod(params: {
  token: string;
  grade: "学前" | "小学" | "初中" | "高中";
}) {
  return getQuestionBankReadContent({
    token: params.token,
    uri: `home/index/textbooks?grade=${params.grade}`,
  });
}

// 按年级获取教材
export function getTextbooksByGrade(params: {
  token: string;
  period: number;
  grade_id?: number;
}) {
  // 验证必需参数
  if (!params.period) {
    throw new Error("period参数不能为空");
  }

  const queryParams = new URLSearchParams();
  queryParams.append("period", params.period.toString());
  if (params.grade_id)
    queryParams.append("grade_id", params.grade_id.toString());

  return getQuestionBankReadContent({
    token: params.token,
    uri: `home/index/textbooks?${queryParams.toString()}`,
  });
}

// 获取册次
export function getUnits(params: {
  token: string;
  materials_id: string | number;
}) {
  return getQuestionBankReadContent({
    token: params.token,
    uri: `home/index/unit?materials_id=${params.materials_id}`,
  });
}

// 获取单元
export function getGroups(params: { token: string; unit_id: string | number }) {
  return getQuestionBankReadContent({
    token: params.token,
    uri: `home/index/group?unit_id=${params.unit_id}`,
  });
}

// 获取课时
export function getLessons(params: {
  token: string;
  group_id: string | number;
}) {
  return getQuestionBankReadContent({
    token: params.token,
    uri: `home/index/lessons?group_id=${params.group_id}`,
  });
}

// 获取单词
export function getWords(params: {
  token: string;
  lessons_id: string | number;
}) {
  return getQuestionBankReadContent({
    token: params.token,
    uri: `home/index/word?lessons_id=${params.lessons_id}`,
  });
}

// 获取句子
export function getTexts(params: {
  token: string;
  lessons_id: string | number;
}) {
  return getQuestionBankReadContent({
    token: params.token,
    uri: `home/index/text?lessons_id=${params.lessons_id}`,
  });
}

// 获取课文跟读
export function getReadings(params: {
  token: string;
  lessons_id: string | number;
}) {
  return getQuestionBankReadContent({
    token: params.token,
    uri: `home/index/read?lessons_id=${params.lessons_id}`,
  });
}

// 获取角色扮演
export function getRolePlays(params: {
  token: string;
  lessons_id: string | number;
}) {
  return getQuestionBankReadContent({
    token: params.token,
    uri: `home/index/roleplay?lessons_id=${params.lessons_id}`,
  });
}

// 随机获取单词
export function getRandomWords(params: {
  token: string;
  period?: string;
  randomnum?: number;
  version_id?: string;
}) {
  const queryParams = new URLSearchParams();
  if (params.period) queryParams.append("period", params.period);
  if (params.randomnum)
    queryParams.append("randomnum", params.randomnum.toString());
  if (params.version_id) queryParams.append("version_id", params.version_id);

  return getQuestionBankReadContent({
    token: params.token,
    uri: `home/index/randword?${queryParams.toString()}`,
  });
}

// 获取模考列表
export function getExamPapers(params: { token: string; exam_type: 0 | 1 }) {
  return getQuestionBankReadContent({
    token: params.token,
    uri: `home/index/paperlist?exam_type=${params.exam_type}`,
  });
}

// 获取试卷详情
export function getExamPaperInfo(params: {
  token: string;
  paper_id: string | number;
}) {
  return getQuestionBankReadContent({
    token: params.token,
    uri: `home/index/paperinfo?paper_id=${params.paper_id}`,
  });
}

// 工具函数：拼接音频URL
export function getAudioUrl(audioPath: string): string {
  if (!audioPath) return "";
  if (audioPath.startsWith("http")) return audioPath;
  return `${AUDIO_BASE_URL}${audioPath}`;
}

// 导出配置常量
export { API_BASE_URL, AUDIO_BASE_URL, DEFAULT_USER_INFO };
